const products = {
  "Urban Slim Denim Pants": 4000,
  "Classic Slim Denim Pants": 3800,
  "Modern High-Rise Denim": 4000,
  "Elevated Slim Denim Pants": 3800,
  "Relaxed Drawstring Denim Jeans": 3500,
  "Casual Cuffed Denim Jeans": 4000,
  "Tailored Slim Denim Jeans": 4000,
  "Classic Straight Denim Jeans": 5500,
  "Sleek Solid Denim Jeans": 4000,
  "Rugged Regular Denim Jeans": 6000,
  "Cobalt Regular Denim Jeans": 5500,
  "Urban Classic Denim Jeans": 6500,
  "Essential Crew Neck Tee": 1500,
  "Textured Crew Neck Tee": 1500,
  "Fitted Crew Neck Tee": 1500,
  "Classic Round Neck Tee": 1500,
  "Bold Graphic Crew Neck Tee": 2000,
  "Vibrant Graphic Crew Tee": 1800,
  "Striking Graphic Crew Tee": 1300,
  "Everyday Crew Neck Tee": 1300,
  "Expressive Typography Crew Tee": 1400,
  "Timeless Mandarin Collar Shirt": 2000,
  "Classic Mandarin Long-Sleeve Shirt": 2500,
  "Textured Short-Sleeve Shirt": 2000,
  "Essential Long-Sleeve Shirt": 2000,
  "Timeless Long-Sleeve Shirt": 2000,
  "Onyx Stream Tapered Jeans": 4800,
  "Azure Drift Loose Straight Jeans": 4500,
  "Faded Azure Tailored Jeans": 5000,
  "Forest Haven Relaxed Cargo Jeans": 5000,
  "Sky Haven Mid-Blue Denim Jeans": 4000,
  "Sleek V-Neck Tee": 1200,
  "Coastal Striped Crew Tee": 1700,
  "Ocean Stripe Slim Fit Round-Neck T-Shirt": 2600,
  "Turquoise Tide Slim V-Neck T-Shirt": 2500,
  "Slim Fit Mid-Rise Ankle Jeans": 4500,
  "Sleek Mid-Rise Skinny Jeans": 5000,
  "Dawn Glow Light Wash Skinny Jeans": 3500,
  "Azure Horizon Relaxed Wide Jeans": 4000,
  "Rustic Dusk High-Rise Skinny Jeans": 4000,
  "Golden Accent Accessory Bundle": 2000,
  "Ebony Silk Textured Tie": 2000,
  "Sage Silk Textured Tie": 2000,
  "Navy Polka Dot Bow Tie Bundle": 2700,
  "Ebony Satin Bow Tie": 1500,
  "Onyx Grosgrain Bow Tie": 1600,
  "Onyx Horizon Beaded Bracelet in Black Snowflake Obsidian": 4500,
  "Rose Dawn Lapel Pin": 2000,
  "Celestial Sphere Lapel Pin": 1700,
  "Twilight Blossom Lapel Pin": 2200,
  "Verdant Leaf Lapel Pin": 1700,
  "Rose Glow Tinted Sunglasses": 500,
  "Amber Dusk Tinted Sunglasses": 600,
  "Haze Tinted Sunglasses": 700,
  "Sparkle Flap Shoulder Bag": 800,
  "Tassel Charm Shoulder Bag": 1400,
  "Quilted Elegance Crossbody Bag": 2000,
  "Gleam Zip Wallet": 900,
  "Ebony Textured Cardholder": 1000,
  "Soft Fringe Classic Scarf": 2000,
  "Shimmer Veil Scarf": 1600,
  "Woven Breeze Scarf": 1600,
  "Midnight Groove Distressed Belt": 3500,
  "Golden Forge Chunky Waist Belt": 3000,
  "Crimson Bold Chunky Waist Belt": 4000,
  "Ebony Straw Accent Waist Belt": 3500,
  "Cream Fine-Knit Polo Shirt for Boys": 2000,
  "Forest Green Jogger Pants for Boys": 1800,
  "Classic Blue Denim Jeans for Boys": 2000,
  "Navy Zip Polo Jumper for Boys": 1800,
  "Navy Horizon Classic Comfort Trousers": 2500,
  "Light Beige Horizon Classic Comfort Trousers": 2500,
  "Open Blue Bondi Classic Jeans": 1800,
  "Light Pastel Brown Classic Cargo Trousers": 1800,
  "Beige Khaki Kenia Classic Trousers": 2300,
  "Charcoal Cozy Baby Dress for Girls": 4000,
  "Monochrome Gingham Dress for Girls": 1500,
  "Navy Denim Button-Down Dress for Girls": 1800,
  "Beige Patch Pocket Skirt for Girls": 2000,
  "Ruby Berry Baby Dress for Girls": 2200,
  "Beige Lace Frill Dress for Girls": 2500,
  "Golden Shimmer Denim Skirt for Girls": 2500,
  "Pink Ditsy Georgia Dress for Girls": 2200,
  "Horizon Travel-Friendly Sweater Vest": 3000,
  "Wanderer Travel-Friendly Short-Sleeve Top": 2400,
  "Horizon Travel-Friendly Sleeveless Top": 2000,
  "Journey Printed Travel-Friendly Dress": 2000,
  "Adriatic Voyage Solid Travel-Friendly Dress": 1800,
  "Leafy Night Voyage Printed Travel-Friendly Dress": 2500,
  "Manzanita Plaid Travel-Ready Long-Sleeve Shirt": 2700,
  "Sagebrush Dobby Travel-Ready Hemp Short-Sleeve Shirt": 3500,
  "Iron Throne Vintage Travel-Ready Pant": 5000,
  "Twine Travel-Ready Short": 4500,
  "Dark Chino Travel-Ready Pant": 5000,
  "Raisin Tonal Travel-Ready Pull-On Short": 1500,
  "Obsidian Versatile 5-Pocket Jogger Set": 4000,
  "Earthy Versatile 5-Pocket Jogger Set": 4500,
  "Forest Versatile 5-Pocket Jogger Set": 3500,
  "Slate Versatile 5-Pocket Jogger Set": 3500,
  "Onyx Athletic Bodysuit Set": 6000,
  "Cloud Tie-Dye Activewear Set": 7000,
  "Black Cherry Athletic Bodysuit Set": 7000,
  "Icy Backless Pocket Bodysuit Set": 6000,
  "Jet Black Open-Back Tee Bodysuit Set": 5000,
  "Chocolate Laced Bodysuit Shorts Set": 6000,
  "Midnight Zip Bodysuit Set": 5500,
};

const orgDetails = {
  orgName: "CAREANS TECH AUTOMATION PVT LTD",
  orgAddress:
    "Building No- Unit NO 307 Plot No 103, Road- A Block, Sector 63, Noida, Uttar Pradesh, 201309",
  phoneNumber: "",
  gstNumber: "09AAMCC0948G1ZH",
};

const shortName = "CT";

const carens = { products, orgDetails, shortName };
export default carens;